import {
  CreateEquipmentChecklistRoutineAssignmentMutation,
  CreateEquipmentChecklistRoutineAssignmentMutationVariables,
  CreateEquipmentChecklistRoutineMutation,
  CreateEquipmentChecklistRoutineMutationVariables,
  EquipmentChecklistRoutineAssignmentCreateInput,
  EquipmentChecklistRoutineCreateInput,
} from '__generated__/graphql';
import useGraphQLClient from 'hooks/graphql/useGraphQLClient/useGraphQLClient';
import {
  CREATE_EQUIPMENT_CHECKLIST_ROUTINE,
  CREATE_EQUIPMENT_CHECKLIST_ROUTINE_ASSIGNMENT,
} from '../queries/equipment-inspection-checklist-routine-mutations';

export default function useEquipmentChecklistRoutines() {
  const client = useGraphQLClient();

  async function createEquipmentChecklistRoutine(input: EquipmentChecklistRoutineCreateInput) {
    const result = await client.request<
      CreateEquipmentChecklistRoutineMutation,
      CreateEquipmentChecklistRoutineMutationVariables
    >({
      document: CREATE_EQUIPMENT_CHECKLIST_ROUTINE,
      variables: { equipmentChecklistRoutine: input },
    });
    return result;
  }

  async function createChecklistRoutineAssignment(input: EquipmentChecklistRoutineAssignmentCreateInput) {
    const result = await client.request<
      CreateEquipmentChecklistRoutineAssignmentMutation,
      CreateEquipmentChecklistRoutineAssignmentMutationVariables
    >({
      document: CREATE_EQUIPMENT_CHECKLIST_ROUTINE_ASSIGNMENT,
      variables: { equipmentChecklistRoutineAssignment: input },
    });
    return result;
  }

  return { createEquipmentChecklistRoutine, createChecklistRoutineAssignment };
}
